<template >
  <div class="imageAnimations">
    <iframe
      src="https://lottie.host/embed/b3c988e0-414f-4fa9-8118-12ba2ce4fe93/KRaLjSkWJt.json"
    ></iframe>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.imageAnimations {
  width: 100%;
  display: flex;
  justify-content: end;
  align-items: center;
}
</style>